/**
 * Route for `agency`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AgencyPage } from "../features/agency/AgencyPage";

export const agencyRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/agency",
	component: AgencyPage,
});

export default agencyRoute;
